import { Box, Button, Paper, Typography } from "@mui/material";
import React, { useCallback, useEffect } from "react";
import EquipmentCard from "./EquipmentCard";
import EquipmentServiceCard from "./EquipmentServiceCard";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../store/types";
import * as actions from "../../../../store/actions";
import { i18n } from "../../../../translate/i18n";
import Spinner from "../../../../components/Spinner";
import { TEquipmentWithServicesEquipmentService } from "../../../../models/iequipmentWithServices";
import { sortBy } from "lodash";

type Props = {
  setStep: CallableFunction,
  showButton: boolean,
}

const EquipmentServicesList: React.FC<Props> = (props) => {
  const dispatch = useDispatch();
  const selectedEquipmentId = useSelector((state: RootState) => state.createService.selectedEquipmentId);
  const equipmentsLoading = useSelector((state: RootState) => state.createService.equipmentsLoading);

  const fetchEquipmentServices = useCallback(
    () => dispatch(actions.createServiceFetchEquipmentServices(selectedEquipmentId)),
    [selectedEquipmentId]
  );

  useEffect(() => {
    fetchEquipmentServices();
  }, [selectedEquipmentId])

  const selectedEquipmentWithServices = useSelector((state: RootState) => state.createService.selectedEquipmentWithServices);
  const equipmentServices = selectedEquipmentWithServices?.equipmentModel?.equipmentServices;
  const equipmentServicesReplicate = selectedEquipmentWithServices?.equipmentServicesReplicate;

  return(
    <Box>
      {
        equipmentsLoading ?
          <Spinner overlay={false} size={36}/>
          :
          <Box sx={{ opacity: equipmentsLoading ? 0.3 : 1 }}>
            <Paper sx={sxs.equipmentCard}>
              <EquipmentCard showEquipmentService={false} />
            </Paper>
            <Typography variant='h6' sx={sxs.equipmentServiceListTitle}>
              {i18n.t('selectServiceType.serviceTypeTitle') as string}
            </Typography>
            <Box sx={sxs.serviceList}>
            { equipmentServices &&
              sortBy(equipmentServices, ['serviceType.name', 'frequency.name'])
                .map((equipService: TEquipmentWithServicesEquipmentService, index: number) => (
                  <EquipmentServiceCard
                    setStep={props.setStep}
                    key={index}
                    equipmentService={equipService}
                    equipmentServicesReplicate={equipmentServicesReplicate}
                  />
                ))
            }
            </Box>
            {props.showButton  && <Box sx={sxs.buttonContainer}>
              <Button variant='outlined' color='error' onClick={() => props.setStep(0)}>
                {i18n.t('selectServiceType.buttonGoBack') as string}
              </Button>
            </Box>}
          </Box>
      }
    </Box>
  )
}

const sxs = {
  equipmentServiceListTitle: {
    margin: '24px 0',
  },
  equipmentCard: {
    padding: '40px 24px',
    gap: '36px',
    borderRadius: '12px',
    border: '1px solid var(--primary-hover, #ECEEF3)',
    boxShadow: '0px 2px 1px -1px rgba(0, 0, 0, 0.20), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)',
    marginBottom: '48px',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  serviceList: {
    '@media (min-width: 1400px)': {
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'space-between',
      justifyContent: 'space-between',
      gap: 2,
    }
  },
}

export default EquipmentServicesList;
